import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import ServiceBoxRegular from '../../Shared/ServiceBox/ServiceBoxRegular/ServiceBoxRegular';
import Config from '../../../Config';
import {handleURL} from '../../../utilities/StringHelpers/StringHelpers';
import {isMobile} from 'react-device-detect';
import downImg from './Images/down.svg';
import {hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {setChosenActionUrl} from '../../Page/SelfCarePage/SelfCareSlice';
import {dwhSelfcareActionGuideClick} from 'app/Components/Page/SelfCarePage/partials/header/dwhReports';
import EpiContext from '@episerver/spa-core/Spa';

const NewCoreProductActionsMain = (props) => {
  const [title, setTitle] = useState(props.iContent.title?.value);
  const [actions, setActions] = useState([]);
  const maxActionsInCloseState = isMobile
    ? props.iContent.mobileMaxActionInCloseState?.value
    : props.iContent.desktopMaxActionInCloseState?.value;
  const [isShowAllActions, setIsShowAllActions] = useState(false);
  const [showAllActionsButton, setShowAllActionsButton] = useState(false);

  const checkMaxActionsInCloseState = () => {
    return isMobile ? actions?.length < maxActionsInCloseState / 2 : actions?.length < maxActionsInCloseState;
  };

  useEffect(() => {
    setActions(handleActionArr());
  }, []);

  useEffect(() => {
    setActions(handleActionArr());
  }, [props?.selectedSubscriber?.orgId]);

  const handleActionArr = () => {
    if (
      props.iContent?.isShowBusinessActions?.value &&
      props.organizationData?.coreProductGroupNewSelfCare?.expandedValue &&
      props.selectedSubscriber?.orgId?.length > 0
    ) {
      let tempActions = props.organizationData?.coreProductGroupNewSelfCare?.expandedValue[0]?.coreProductActions?.expandedValue;
      return tempActions;
    } else {
      if (props.iContent.coreProductActions?.expandedValue) {
        return props.iContent.coreProductActions?.expandedValue;
      } else {
        setTitle('');
        return [];
      }
    }
  };

  function reportDwh(action) {
    const customerName = props?.selectedSubscriber?.productFirstName + ' ' + props?.selectedSubscriber?.productLastName;
    const subscriber = props?.selectedSubscriber?.productSubscriberNo;
    const idNumber = props?.authentication?.userDetails?.IDNumber;
    const ban = props?.selectedSubscriber?.ban;
    const psid = null;
    const crmId = null;
    const param1 = action?.actionName?.value;
    const param9 = null;
    const param10 = null;
    dwhSelfcareActionGuideClick(customerName, subscriber, idNumber, ban, psid, crmId, param1, null, param9, param10);
  }

  const actionRedirect = (action) => {
    reportDwh(action);
    props.setChosenActionUrl(action?.actionUrl?.value);
    //buildUrlOpenPageSelfAndRestBlank(action?.actionUrl?.value);
    handleURL(action?.actionUrl?.value, EpiContext);
  };

  useEffect(() => {
    let actionsList = handleActionArr();
    setActions(isShowAllActions ? actionsList : actionsList?.slice(0, maxActionsInCloseState));
    setShowAllActionsButton(actionsList?.length > maxActionsInCloseState);
  }, [isShowAllActions]);

  useEffect(() => {
    if (props.selfCareSlice.chosenActionUrl.length > 1 && props.selfCareSlice.otpExtendedFinished) {
      window.scrollTo(0, 0);
      //buildUrlOpenPageSelfAndRestBlank(props.selfCareSlice.chosenActionUrl);
      handleURL(props.selfCareSlice.chosenActionUrl, EpiContext);
    }
  }, [props.selfCareSlice.otpExtendedFinished]);

  return (
    <div className='newCoreProductActionsComponent'>
      <div className='title'>{title}</div>
      <div
        className={checkMaxActionsInCloseState() ? 'less-than-max-actions-in-close' : 'actions'}
        style={{gridTemplateColumns: `repeat(${maxActionsInCloseState > 7 ? 7 : maxActionsInCloseState}, 1fr)`}}>
        {actions?.map((action, index) => {
          return (
            <ServiceBoxRegular
              key={index}
              badgeText={action?.tagText?.value}
              badgeColorProperty={action?.tagColor?.value}
              badgeBackgroundColorProperty={action?.tagBackgroundColor?.value}
              isHaveBadge={action?.tagText?.value !== ''}
              backgroundColorProperty={'#fff'}
              backgroundImageUrl={Config.epiBaseUrl + action?.actionIcon?.value?.url}
              action={action}
              actionUrl={action?.actionUrl?.value}
              actionName={action?.actionName?.value}
              callback={(action) => actionRedirect(action)}
            />
          );
        })}
      </div>
      {showAllActionsButton && (
        <div className='accordion' onClick={() => setIsShowAllActions(!isShowAllActions)}>
          <div className='accordion-title'>{isShowAllActions ? 'הצג פחות' : props?.iContent?.showAllText?.value}</div>
          <div className='accordion-img-wrapper'>
            <Image className={isShowAllActions ? 'accordion-img rotate-arrow' : 'accordion-img'} src={downImg} alt='downImg' />
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication?.loginData,
    isFetchData: state.selfcarePage.isFetchData,
    selfCareSlice: state.selfcarePage,
    organizationData: state.selfcarePage.organizationState,
    selectedSubscriber: state.selfcarePage.selectedSubscriber,
  };
};

const mapDispatchToProps = {
  hideAppLoader,
  setChosenActionUrl,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewCoreProductActionsMain);
